<template>
	<v-switch v-model="autoUpdatedEnabled" :label="$t('auto_update')" color="primary" class="mr-9" hide-details />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	data() {
		return {
			autoUpdatedEnabled: false,
		};
	},
	watch: {
		async autoUpdatedEnabled(enabled) {
			localStorage.setItem('autoUpdate', enabled);
			if (enabled) {
				await this.processSocketQueue();
			}
		},
	},
	methods: {
		...mapActions({
			processSocketQueue: 'planning/processSocketQueue',
		}),
	},
	beforeMount() {
		const autoUpdateValue = localStorage.getItem('autoUpdate');
		this.autoUpdatedEnabled = autoUpdateValue !== 'false';
	},
};
</script>
